export default __webpack_public_path__ + "static/media/Icon feather-database.a97a64ea.svg";